/**
 * Odd Muse search results page (Option B)
 * 1. Remembers the results page (query, filters, sort, page, scroll) when a product is opened,
 *    so the product page can offer "Back to results" and going back lands on the same card.
 * 2. On a no-results page, asks Shopify's predictive search for a spelling suggestion and the
 *    closest pieces, and shows them only if Shopify returns something.
 */
(function () {
  var STORE_KEY = 'om:search-return';

  function readReturn() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeReturn(data) {
    try {
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (error) {
      /* Storage unavailable: back navigation still works through browser history */
    }
  }

  function navigationType() {
    var entry = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return entry ? entry.type : '';
  }

  function initReturnState(root) {
    var terms = root.getAttribute('data-om-terms') || '';
    var count = root.getAttribute('data-om-count') || '';

    // Save state when a product card is opened (capture phase, before navigation)
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('#ProductGridContainer a[href*="/products/"], [data-om-closest] a[href*="/products/"]');
        if (!link) return;
        writeReturn({
          url: window.location.href,
          terms: terms,
          count: count,
          y: window.scrollY,
          at: Date.now(),
        });
        if (window.OMRecentSearches && terms) window.OMRecentSearches.add(terms);
      },
      true
    );

    // Restore the scroll position when the customer comes back to the same results URL
    var saved = readReturn();
    if (saved && saved.url === window.location.href && navigationType() === 'back_forward') {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.requestAnimationFrame(function () {
        window.scrollTo(0, saved.y || 0);
      });
    }
  }

  function formatMoney(amount) {
    var value = parseFloat(amount);
    if (isNaN(value)) return '';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var locale = document.documentElement.lang || 'en-GB';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      }).format(value);
    } catch (error) {
      return value.toFixed(2);
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function searchUrl(term) {
    if (window.OMRecentSearches) return window.OMRecentSearches.searchUrl(term);
    return '/search?type=product&q=' + encodeURIComponent(term);
  }

  function initNoResults(root) {
    var dym = root.querySelector('[data-om-did-you-mean]');
    var closest = root.querySelector('[data-om-closest]');
    var list = root.querySelector('[data-om-closest-list]');
    var term = (root.getAttribute('data-om-terms') || '').trim();
    if (!dym || !closest || !list || term.length < 2) return;

    // Decode the escaped term written by Liquid
    var decoder = document.createElement('textarea');
    decoder.innerHTML = term;
    term = decoder.value;

    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var params = new URLSearchParams({
      q: term,
      'resources[type]': 'query,product',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'hide',
    });

    fetch(base + '.json?' + params.toString())
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data.resources || !data.resources.results) return;
        var results = data.resources.results;

        // "Did you mean": only when Shopify suggests a different query
        var suggestion = (results.queries || []).find(function (query) {
          return query.text && query.text.toLowerCase() !== term.toLowerCase();
        });
        if (suggestion) {
          dym.textContent = 'Did you mean ';
          var link = el('a', '', suggestion.text);
          link.href = searchUrl(suggestion.text);
          dym.appendChild(link);
          dym.appendChild(document.createTextNode('?'));
          dym.hidden = false;
        }

        // Closest pieces
        var products = results.products || [];
        if (!products.length) return;
        products.forEach(function (product) {
          var item = el('li', 'om-ps__product');
          var link = el('a', 'om-ps__product-link');
          link.href = product.url;
          var media = el('span', 'om-ps__media');
          var imageUrl = (product.featured_image && product.featured_image.url) || product.image;
          if (imageUrl) {
            var img = document.createElement('img');
            img.src = imageUrl + (imageUrl.indexOf('?') > -1 ? '&' : '?') + 'width=480';
            img.alt = (product.featured_image && product.featured_image.alt) || product.title;
            img.loading = 'lazy';
            img.className = 'om-ps__image';
            media.appendChild(img);
          }
          link.appendChild(media);
          link.appendChild(el('span', 'om-ps__title', product.title));
          link.appendChild(el('span', 'om-ps__price', formatMoney(product.price)));
          item.appendChild(link);
          list.appendChild(item);
        });
        closest.hidden = false;
      })
      .catch(function () {
        /* Suggestions are an enhancement: the page already offers chips and bestsellers */
      });
  }

  function init() {
    var root = document.querySelector('[data-om-search]');
    if (!root) return;
    initReturnState(root);
    if (root.querySelector('[data-om-did-you-mean]')) initNoResults(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
